import { memo } from 'react';

const RequestStatusRow = memo(({ icon, label, value, showDivider = true }) => (
  <div
    className={[
      'flex w-full items-center p-4.5 desktop:p-3',
      showDivider ? 'border-b border-merchant-border' : '',
    ].join(' ')}
  >
    <div className="flex min-w-0 flex-1 items-center gap-1.5 desktop:gap-2">
      <div className="flex shrink-0 items-center justify-center rounded-[18px] bg-merchant-bg-subtle p-[5px] md:rounded-[22px] md:p-1.5 desktop:rounded-[30px] desktop:p-2">
        <img src={icon} alt="" className="size-3 md:size-3.5 desktop:size-4.5" aria-hidden="true" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <p className="text-sm font-normal text-merchant-text-secondary">{label}</p>
        <p className="desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-text-primary">
          {value}
        </p>
      </div>
    </div>
  </div>
));

RequestStatusRow.displayName = 'RequestStatusRow';

export default RequestStatusRow;
